import { RcClasses } from '../../../../foundation';
export var RcListSubheaderClasses = RcClasses(['gutters', 'inset'], 'RcListSubheader');
